import { trackAutoEvent } from '../../vendor/splitmetrics-track/index';



export const EVENT_NAME = 'apple_watch_gallery_slide_inaction';


export default (intervalParams) => {
  trackAutoEvent(EVENT_NAME, intervalParams, {});
};



// WEBPACK FOOTER //
// ./src/lib/track-event/apple-watch-gallery-slide-inaction.js